import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PageContainer } from '@/components/shared/PageContainer';
import { queryClient } from '@/lib/utils/queryClient';
import { CertifiedMaterialsTable } from '../-components/CertifiedMaterialsTable';
import { ordersQueryOptions } from '../-hooks/useCertifiedMaterialsQuery';
import { buildOrdersListParams } from '../-utils/listParams';

const searchSchema = z.object({
  page: z.number().int().min(1).optional(),
  limit: z.number().int().min(5).max(500).optional(),
  sort: z.string().optional(),
  filters: z.record(z.array(z.string())).optional(),
  quickFilter: z.enum(['needs_attention', 'completed']).optional(),
  orderId: z.string().optional(),
  dialog: z.enum(['import-orders', 'upload-docs', 'review-docs']).optional(),
});

export const Route = createFileRoute('/(client)/certified-materials/(pages)/')({
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => ({
    page: search.page,
    limit: search.limit,
    sort: search.sort,
    filters: search.filters,
    quickFilter: search.quickFilter,
  }),
  loader: ({ deps }) =>
    queryClient.ensureQueryData(
      ordersQueryOptions(buildOrdersListParams(deps)),
    ),
  component: CertifiedMaterialsPage,
});

function CertifiedMaterialsPage() {
  return (
    <PageContainer>
      <CertifiedMaterialsTable />
    </PageContainer>
  );
}
